import { useServices } from "@/services-context";
import { WhatWeDoDesktop } from "@/pages-react/what-we-do/what-we-do-desktop.tsx";
import { WhatWeDoMobile } from "@/pages-react/what-we-do/what-we-do-mobile.tsx";
import { LocationHook, RouteHook, useLocation, useRoute } from "preact-iso";
import { LayoutTypes, useLayoutType } from "@/util-react/layout.tsx";
import { pageSuspense, useSuspenseLoader } from "@/helpers/suspense";
import { Services } from "@/services/services";
import { StaticPagesType } from "@/context/static-pages";
import { PageTags } from "@/elements-react/document-elements/page-tags.tsx";
import { Url } from "@/helpers/url.ts";
import { SeoMarkupDataset } from "@/services/seo-markup.ts";

const fetchPageData = async (params: { services: Services; location: LocationHook; route: RouteHook }) => {
  const { services, location, route } = params;

  await services.initialize.prepare({
    location: location,
    route: route,
  });

  const registryUrl = Url.normalizeRoute(route.path);
  const alternates = await services.routes.resolveAlternates(registryUrl);

  if (!services.staticPages.has(StaticPagesType.whatWeDo)) {
    await services.staticPages.fetchStaticPage(StaticPagesType.whatWeDo);
  }

  return {
    type: "static",
    canonical: registryUrl,
    alternates: alternates,
  };
};

const getPageComponent = (layoutType: LayoutTypes) => {
  switch (layoutType) {
    case LayoutTypes.TYPE_DESKTOP:
      return WhatWeDoDesktop;
    case LayoutTypes.TYPE_MOBILE:
      return WhatWeDoMobile;
  }
};

export const WhatWeDoPage = pageSuspense(() => {
  const route = useRoute();
  const location = useLocation();
  const services = useServices();
  const { layoutType } = useLayoutType();

  const seoMarkupDataset = useSuspenseLoader({
    key: "what-we-do-route",
    loader: () =>
      fetchPageData({
        services: services,
        location: location,
        route: route,
      }),
  }) as SeoMarkupDataset;

  const content = services.staticPages.getStaticPage(StaticPagesType.whatWeDo);
  const PageComponent = getPageComponent(layoutType);

  return (
    <div style={{ display: "contents" }}>
      <PageComponent content={content} />
      <PageTags seo={seoMarkupDataset} />
    </div>
  );
});
